import AuthLayout from './AuthLayout.container';

export default AuthLayout;
